export * from './AppHeapScript';
export * from './DocumentHeapScript';
